// src/components/Footer.jsx
import React from "react";

const Footer = ({ setCurrentPage }) => {
  return (
    <footer className="bg-gray-900 text-white p-8 mt-16 rounded-t-3xl shadow-inner border-t-4 border-teal-600">
      <div className="container mx-auto text-center text-sm md:text-base">
        <p className="mb-4">
          &copy; {new Date().getFullYear()} Insperity Games. All rights
          reserved.
        </p>
        <div className="mt-3 flex justify-center space-x-8 text-3xl">
          {/* Example Social Media Icons (using Font Awesome) */}
          <a
            href="#"
            className="hover:text-blue-400 transition-colors duration-200"
          >
            <i className="fab fa-facebook-f"></i>
          </a>
          <a
            href="#"
            className="hover:text-blue-400 transition-colors duration-200"
          >
            <i className="fab fa-twitter"></i>
          </a>
          <a
            href="#"
            className="hover:text-blue-400 transition-colors duration-200"
          >
            <i className="fab fa-linkedin-in"></i>
          </a>
          <a
            href="#"
            className="hover:text-red-400 transition-colors duration-200"
          >
            <i className="fab fa-youtube"></i>
          </a>
        </div>
        <div className="mt-6 space-x-4">
          <button
            onClick={() => setCurrentPage("privacy")}
            className="text-blue-300 hover:text-blue-400 transition-colors duration-200 text-sm md:text-base"
          >
            Privacy Policy
          </button>
          <span className="text-gray-500">|</span>
          <button
            onClick={() => setCurrentPage("contact")}
            className="text-blue-300 hover:text-blue-400 transition-colors duration-200 text-sm md:text-base"
          >
            Contact Us
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
